$(document).ready(function(e) {
$('.navbar-toggler').on('click', function(e) {
$('body').toggleClass('nav-open');
e.stopPropagation();
});
});

$(".navbar-collapse").click(function(e){
	e.stopPropagation();
});

$(document).click(function(e) {
$('body').removeClass('nav-open');
});

// SubMenu dropdown on click
$(document).ready(function(){    
	$('li > button.btn_append').on('click', function(e) {           
		$(this).parent().toggleClass('current');
		$(this).parent().siblings().removeClass('current');
	});  
});

// On Scroll add class 
$(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    if (scroll >= 150) {
        $("body").addClass("darkHeader");
    }
    if (scroll <= 50) {
        $("body").removeClass("darkHeader");
    }
});

// Search bar JS
jQuery(document).ready(function(e) {
jQuery('#search-oppener').on('click', function(e) {
jQuery('body').toggleClass('search-active');
e.stopPropagation();
});
jQuery('#search-oppener').click(function(e){
e.stopPropagation();
});

jQuery('.aside-openner').on('click', function(e) {
jQuery('.collections #aside').toggleClass('aside-active');
e.stopPropagation();
});
jQuery('.aside-oppener').click(function(e){
e.stopPropagation();
});
});

// Visual Slider
$('.visual-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  speed: 800,
  autoplay: true,
  arrows: false
});




// client-slider

$('.client-slider').slick({
  arrows: false,
  dots: true,
  slidesToShow: 3,
  responsive: [
    {
      breakpoint: 768.98,
      settings: {
        arrows: false,
        slidesToShow: 2
      }
    },
    {
      breakpoint: 639.98,
      settings: {
        arrows: false,
        slidesToShow: 1
      }
    }
  ]
});


// work slider

var $status = $('.pagingInfo');
var $slickElement = $('.work-slider');

  $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
      //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
      var i = (currentSlide ? currentSlide : 0) + 1;
      $status.text(i + '/' + slick.slideCount);
  });
$slickElement.slick({
 slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  fade: true,
  dots: false
});


// featured slider

$('.featured-slider').slick({
  arrows: false,
  slidesToShow: 3,
  responsive: [
    {
      breakpoint: 768.98,
      settings: {
       dots: true,
        slidesToShow: 2
      }
    },
    {
      breakpoint: 639.98,
      settings: {
        arrows: false,
        slidesToShow: 1
      }
    }
  ]
});

//Same Height 
jQuery(document).ready(function(){
jQuery('.collection-block').each(function(){ 
var highestBox = 0;
jQuery('.card-title', this).each(function(){
if(jQuery(this).height() > highestBox) {
  highestBox = jQuery(this).height(); 
}
}); 
jQuery('.card-title', this).height(highestBox);
            
});
jQuery('.collection-block').each(function(){ 
var highestBox = 0;
jQuery('.img-hol', this).each(function(){
if(jQuery(this).height() > highestBox) {
  highestBox = jQuery(this).height(); 
}
}); 
jQuery('.img-hol', this).height(highestBox);
            
});
});


// slick nav slider

 $('.slider-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.slider-nav'
});
$('.slider-nav').slick({
  infinite: false,
  slidesToShow: 5,
  slidesToScroll: 3,
  asNavFor: '.slider-for',
  arrows: true,
  dots: false,
  focusOnSelect: true
});

// Read more read less 


jQuery(document).ready(function() {
  
  $('.moreless-button').click(function() {
  $('.moretext').toggle();
  if ($('.moreless-button').text() == "Read more") {
    $(this).text("Read less")
  } else {
    $(this).text("Read more")
  }
});
  
});


// quantity js 

    jQuery('<div class="quantity-nav"><div class="quantity-button quantity-up">+</div><div class="quantity-button quantity-down">-</div></div>').insertAfter('.quantity input');
    jQuery('.quantity').each(function() {
      var spinner = jQuery(this),
        input = spinner.find('input[type="number"]'),
        btnUp = spinner.find('.quantity-up'),
        btnDown = spinner.find('.quantity-down'),
        min = input.attr('min'),
        max = input.attr('max');

      btnUp.click(function() {
        var oldValue = parseFloat(input.val());
        if (oldValue >= max) {
          var newVal = oldValue;
        } else {
          var newVal = oldValue + 1;
        }
        spinner.find("input").val(newVal);
        spinner.find("input").trigger("change");
      });

      btnDown.click(function() {
        var oldValue = parseFloat(input.val());
        if (oldValue <= min) {
          var newVal = oldValue;
        } else {
          var newVal = oldValue - 1;
        }
        spinner.find("input").val(newVal);
        spinner.find("input").trigger("change");
      });

    });



setTimeout(function(){
  $('.new-product-slider').slick({
    slidesToShow: 1,
    autoplay: false,
    autoplaySpeed: 1000,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 767.98,
        settings: {
          slidesToShow: 1,
         slidesToScroll: 1,
          arrows: true
        }
      },
      {
        breakpoint: 639.98,
        settings: {
          slidesToShow: 1,
          arrows: true
        }
      }
    ]
  });
}, 50);


// Best product slider

setTimeout(function(){
  $('.best-product-slider').slick({
    slidesToShow: 1,
    autoplay: false,
    autoplaySpeed: 1000,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 767.98,
        settings: {
          slidesToShow: 1,
         slidesToScroll: 1,
          arrows: true
        }
      },
      {
        breakpoint: 639.98,
        settings: {
          slidesToShow: 1,
          arrows: true
        }
      }
    ]
  });
}, 50);

// trending slider

setTimeout(function(){
  $('.trending-slider').slick({
    slidesToShow: 4,
    autoplay: false,
    autoplaySpeed: 1000,
    slidesToScroll: 4,
    arrows: true,
    dots: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 991.98,
        settings: {
          slidesToShow: 3,
         slidesToScroll: 3,
          arrows: true
        }
      },
      {
        breakpoint: 767.98,
        settings: {
          slidesToShow: 2,
          arrows: true
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          arrows: true
        }
      }
    ]
  });
}, 50);


setTimeout(function(){
  $('.blog-slider').slick({
    slidesToShow: 2,
    autoplay: false,
    autoplaySpeed: 1000,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 991.98,
        settings: {
          slidesToShow: 1,
         slidesToScroll: 1,
          arrows: true
        }
      },
      {
        breakpoint: 639.98,
        settings: {
          slidesToShow: 1,
          arrows: true
        }
      }
    ]
  });
}, 50);


// Best seller Slider Script
setTimeout(function(){
  $('.tranding-slide').slick({
    slidesToShow: 4,
    autoplay: false,
    autoplaySpeed: 2000,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
         slidesToScroll: 1,
          arrows: false,
          autoplay: true
        }
      },
      {
        breakpoint: 639.98,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
}, 50);



$(document).ready(function() {
    $("#show_hide_password a").on('click', function(event) {
        event.preventDefault();
        if($('#show_hide_password input').attr("type") == "text"){
            $('#show_hide_password input').attr('type', 'password');
            $('#show_hide_password i').addClass( "fa-eye-slash" );
            $('#show_hide_password i').removeClass( "fa-eye" );
        }else if($('#show_hide_password input').attr("type") == "password"){
            $('#show_hide_password input').attr('type', 'text');
            $('#show_hide_password i').removeClass( "fa-eye-slash" );
            $('#show_hide_password i').addClass( "fa-eye" );
        }
    });
});



